import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Common from '../../utilities/common';
import $ from "jquery";
import { DataGrid, GridRowSelectionModel, GridRowId, GridToolbar, GridCsvExportOptions, GridToolbarContainer, useGridApiContext, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector } from '@mui/x-data-grid';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import provincias from '../provincias.png';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import EntityPermissions from '../../components/EntityPermissions';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntitySettings from '../../components/EntitySettings';
import EditIcon from '@mui/icons-material/Edit';
import { TimerJobModel } from './TimerJobModel';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

export interface IProvinciasState {
    data: TimerJobModel[];
    loading: boolean;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
    selectedRow: GridRowId[];
    activateText: string;
    activateIcon: JSX.Element;
    checkBoxSelection: boolean;
}

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'provincias' })}
        >
            Exportar CSV
        </Button>
    );
}

export default class TimerJobs extends React.Component<{}, IProvinciasState> {
    _file: any;
    _fileContent: any[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            rowSelected: null,
            openRowMenu: false,
            selectedRow: [],
            activateText: 'Activar',
            activateIcon: <CheckCircleOutlineOutlinedIcon/>,
            checkBoxSelection: false
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'Timer Jobs',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <AvTimerOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Timer Jobs
                                </Typography>
                            </Grid>
                            <Grid item xs={2} className='entitySettings'>
                                <EntitySettings entity={Entity.Provincias}/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <DataGrid
                            autoHeight
                            loading={this.state.loading}
                            slots={{ toolbar: this.CustomToolbar.bind(this) }}
                            hideFooter={this.state.data.length <= 30}
                            rows={this.state.data}
                            columns={[
                                { 
                                    field: 'id', 
                                    headerName: 'ID', 
                                    width: 100,
                                    renderCell: ({ row }) => (
                                        this.RenderIconStatus(row, 'id')
                                    )
                                },
                                { 
                                    field: 'active', 
                                    headerName: 'Activo', 
                                    width: 75,
                                    renderCell: ({ row }) => (
                                        Common.RenderBoolean(row, 'active')
                                    ) 
                                },
                                { field: 'name', headerName: 'Nombre', flex: 1 },
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 30 }
                                },
                            }}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            pageSizeOptions={[30, 60, 100]}
                            checkboxSelection={this.state.checkBoxSelection}
                            onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                this.setState({
                                    selectedRow: row,
                                    openNewForm: false,
                                    openDeleteForm: false,
                                    openEditForm: false
                                });
                            }}
                        />
                    </Box>
                    <Menu
                        anchorEl={this.state.rowSelected}
                        open={this.state.openRowMenu}
                        onClose={() => {
                            this.setState(
                                {
                                    rowSelected: null,
                                    openRowMenu: false
                                }
                            );
                        }}
                    >
                        <MenuItem onClick={() => {
                                this.Activate(this.state.activateText == 'Activar');
                        }}>
                            <ListItemIcon>
                                {
                                    this.state.activateIcon
                                }
                            </ListItemIcon>
                            <ListItemText>
                                {
                                    this.state.activateText
                                }
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {
                                this.setState(
                                    {
                                        openNewForm: false,
                                        openEditForm: true,
                                        openDeleteForm: false,
                                        openRowMenu: false
                                    }
                                );
                        }}>
                            <ListItemIcon>
                                <EditIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Modificar</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {
                                this.setState(
                                    {
                                        openNewForm: false,
                                        openEditForm: false,
                                        openDeleteForm: true,
                                        openRowMenu: false
                                    }
                                );
                        }}>
                            <ListItemIcon>
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Eliminar</ListItemText>
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => {
                                const id = this.state.selectedRow[0];
                                window.location.href = `/settings/job/history?id=${id}`;
                        }}>
                            <ListItemIcon>
                                <HistoryOutlinedIcon/>
                            </ListItemIcon>
                            <ListItemText>
                                Historial de ejecución
                            </ListItemText>
                        </MenuItem>
                    </Menu>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/jobs`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedRow: [],
                    rowSelected: null,
                    openRowMenu: false,
                    loading: false
                }
            );
        })
    }

    private Activate(activate: boolean): void {
        const id = this.state.selectedRow[0];
        const job: TimerJobModel | undefined = this.state.data.find((value: TimerJobModel) => {
            return value.id == id
        });

        if(job != null) {
            job.active = activate;

            let url = `${Common.END_POINT}/jobs/${id}/activate`;

            $.ajax((
                {
                    url: url,
                    type: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    data: JSON.stringify(job),
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                    }
                }
            )).done((response: any[]) => {
                this.Get();
            })
        }
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Crear}>
                    <Button startIcon={<AddOutlinedIcon />} variant="contained" onClick={() => {
                        this.setState(
                            {
                                openNewForm: true,
                                openEditForm: false,
                                openDeleteForm: false
                            }
                        );
                    }}>
                        Nuevo
                    </Button>
                </SecurityTrimmer>
                {
                    ExportButton()
                }
            </Stack>
        )
    }

    private RenderIconStatus(row: any, key: string): JSX.Element {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                <Button variant='text' style={{color: '#333'}} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    this.setState(
                        {
                            rowSelected: event.currentTarget,
                            openRowMenu: true,
                            activateText: !row['active'] ? 'Activar' : 'Desactivar',
                            activateIcon: !row['active'] ? <CheckCircleOutlineOutlinedIcon/> : <CancelOutlinedIcon />
                        }
                    );
                }}>
                    {
                        row[key]
                    }
                </Button>
            </SecurityTrimmer>
        )
    }
}